<template>
  <div class="content-wrapper">
    <PageHeader screenName="Variáveis de Integração" :linkItems="linkItems" />

    <main class="card p-2">
      <ConfirmModal
        :modalShow="modalSubmit.show"
        typeModal="success"
        itemIdentifier="form"
        :infoText="{ success: modalSubmit.infoText }"
        @confirmed="submitForm"
        @canceled="modalSubmit.show = false"
      />
      <ConfirmModal
        :modalShow="modalCancel.show"
        typeModal="danger"
        itemIdentifier="form"
        :infoText="{ danger: 'Ao cancelar, todos os dados não salvos dessa configuração serão perdidos.' }"
        @confirmed="buscarInfoDoDepartamento(form.departamento.id_departamento)"
        @canceled="modalCancel.show = false"
      />
      <ModalShowError
        :modalShow="modalError.showModal"
        :typeModal="modalError.typeModal"
        :infoText="modalError.infoText"
        @confirmed="modalError.showModal = false"
      />
      <SucessoModal
        :modalShow="modalSucesso.showModal"
        :typeModal="modalSucesso.typeModal"
        caseModal="criacao"
        :infoText="modalSucesso.infoText"
        @confirmed="modalSucesso.showModal = false; buscarInfoDoDepartamento(form.departamento.id_departamento)"
      />

      <section class="card-header px-0" v-if="integracaoAtiva">
        <b-alert variant="success" show>
          <div class="alert-body">
            <feather-icon icon="CheckCircleIcon" size="22" class="mr-1" />
            <span class="font-weight-bold">Integração Ativa!</span>
            <span class="text-success font-weight-normal">
              Configurada por {{ responsavelAtivacao }} em {{ dataAtivacao }}
            </span>
          </div>
        </b-alert>
      </section>

      <section class="form">
        <validation-observer ref="integracaoRules">
          <b-form>
            <ConfiguracaoDepartamento
              :form="form"
              :optionsDepartamentos="optionsDepartamentos"
              :permiteGerenciar="permiteGerenciar"
              :adicionarCertificado.sync="adicionarCertificado"
              @update:departamento="form.departamento = $event"
              @update:certificado="form.certificado = $event"
              @update:chaveAcesso="form.chaveAcesso = $event"
              @update:idSolicitante="form.idSolicitante = $event"
            />

            <ParametrosDados
              v-if="form.departamento"
              :form="form"
              :permiteGerenciar="permiteGerenciar"
              @update:dataFiltro="form.dataFiltro = $event"
            />

            <AgendamentoEnvio
              v-if="form.departamento"
              :form="form"
              :permiteGerenciar="permiteGerenciar"
              @update:periodicidade="form.periodicidade = $event"
              @update:dataInicioEnvio="form.dataInicioEnvio = $event"
              @update:numeroDiaSemana="form.numeroDiaSemana = $event"
            />
          </b-form>
        </validation-observer>
      </section>

      <section class="mt-2" v-if="form.departamento">
        <h3 class="mb-3">Unidades Operacionais do {{ form.departamento.descricao }}</h3>
        <b-alert variant="warning" show class="align-items-center p-3 text-center" v-if="!formCompleto">
          <feather-icon icon="AlertTriangleIcon" size="16" class="mr-2" />
          <span>Preencha todos os campos obrigatórios para prosseguir.</span>
        </b-alert>

        <UnidadesIntegracao
          v-if="formCompleto"
          :form="form"
          :permiteGerenciar="permiteGerenciar"
          @update-unidades="form.unidades = $event"
        />
      </section>

      <section class="d-flex justify-content-right mb-1 mt-2" v-if="form.departamento">
        <b-button
          id="save-config"
          class="mr-2 mb-2-sm"
          variant="custom-blue"
          @click.prevent="saveAction"
          :disabled="!formCompleto || !permiteGerenciar"
        >
          <feather-icon icon="CheckIcon" class="mr-50" />
          <span class="align-middle">Salvar Configurações</span>
          <output v-if="saving" class="spinner-border spinner-border-sm ml-1"></output>
        </b-button>
        <b-button
          id="cancel-config"
          :disabled="saving || !permiteGerenciar || !formCompleto"
          variant="outline-danger"
          @click.prevent="cancelAction"
        >
          <feather-icon icon="XIcon" class="mr-50" />
          <span class="align-middle">Cancelar</span>
        </b-button>
      </section>
    </main>
  </div>
</template>

<script>
import { BForm, BButton, BAlert } from 'bootstrap-vue';
import { ValidationObserver } from 'vee-validate';
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue';
import ConfirmModal from '@/views/components/custom/modals/ConfirmModal.vue';
import ModalShowError from '@/views/components/custom/modals/ModalShowError.vue';
import SucessoModal from '@/views/components/custom/modals/SucessoCriacaoEdicaoModal.vue';
import UnidadesIntegracao from './parts/Unidades-integracao.vue';
import ConfiguracaoDepartamento from './parts/ConfiguracaoDepartamento.vue';
import ParametrosDados from './parts/ParametrosDados.vue';
import AgendamentoEnvio from './parts/AgendamentoEnvio.vue';
import moment from 'moment';
import handleErrorsService from './Services/HandleErrors';
import { actions, subjects } from '@/libs/acl/rules';

export default {
  title: 'Variáveis de Integração',
  components: {
    BForm, BButton, BAlert, ValidationObserver, PageHeader, ConfirmModal,
    ModalShowError, SucessoModal, UnidadesIntegracao, ConfiguracaoDepartamento,
    ParametrosDados, AgendamentoEnvio
  },

  data() {
    return {
      linkItems: [{ name: 'Integração RNDS', routeName: 'integracao-rnds' }],
      formCompleto: false,
      saving: false,
      adicionarCertificado: false,
      form: {
        idConfiguracaoDepartamentoRnds: null,
        departamento: null,
        certificado: null,
        nomeCertificado: null,
        dataFiltro: null,
        chaveAcesso: null,
        idSolicitante: null,
        periodicidade: null,
        dataInicioEnvio: null,
        numeroDiaSemana: null,
        unidades: [],
        tipoDataFiltro: 'data_atendimento_vacinacao',
        errors: {
          departamento: null, certificado: null, chaveAcesso: null,
          idSolicitante: null,
          dataFiltro: null, periodicidade: null, dataInicioEnvio: null, numeroDiaSemana: null
        }
      },
      optionsDepartamentos: [],
      modalSubmit: { show: false, infoText: '' },
      modalCancel: { show: false },
      modalError: { showModal: false, typeModal: 'error', infoText: '' },
      modalSucesso: { showModal: false, typeModal: 'success', infoText: 'Integração foi ativada com sucesso' },
      permiteGerenciar: false,
      integracaoAtiva: false,
      responsavelAtivacao: null,
      dataAtivacao: null
    };
  },

  mounted() {
    this.permiteGerenciar = this.$can(actions.GERENCIAR, subjects.INTEGRACAO_RNDS_MENU_ROTAS);
    this.getDepartamentos();
  },

  watch: {
    'form.departamento'(val) {
      if (val) this.buscarInfoDoDepartamento(val.id_departamento);
      this.verificaFormCompleto();
    },
    'form.certificado'() { this.verificaFormCompleto(); },
    'form.chaveAcesso'() { this.verificaFormCompleto(); },
    'form.idSolicitante'() { this.verificaFormCompleto(); },
    'form.dataFiltro'() { this.verificaFormCompleto(); },
    'form.periodicidade'() { this.verificaFormCompleto(); },
    'form.dataInicioEnvio'() { this.verificaFormCompleto(); },
    'form.tipoDataFiltro'() { this.verificaFormCompleto(); }
  },

  methods: {
    verificaFormCompleto() {
      const periodicidadeCompleta = (this.form.periodicidade === 'Semanal' && this.form.numeroDiaSemana) || this.form.periodicidade;
      this.formCompleto = !!(
        this.form.departamento &&
        ((this.form.certificado && this.form.chaveAcesso) || this.form.nomeCertificado) &&
        this.form.idSolicitante &&
        this.form.tipoDataFiltro && this.form.dataFiltro && periodicidadeCompleta && this.form.dataInicioEnvio
      );
    },

    getDepartamentos() {
      this.$http.get(this.$api.departamento(), { params: { ativo: true } })
        .then(({ data }) => { this.optionsDepartamentos = data; });
    },

    buscarInfoDoDepartamento(idDepartamento) {
      this.clearForm();
      this.$http.get(this.$api.getConfigRndsDepartamento(idDepartamento)).then(({ data }) => {
        this.form.idConfiguracaoDepartamentoRnds = data.idConfiguracaoDepartamentoRnds;
        this.form.tipoDataFiltro = data.tipoData || 'data_atendimento_vacinacao';
        this.form.dataFiltro = data.dataRegistroEnvio;
        this.form.periodicidade = data.periodicidadeAgendamento;
        this.form.dataInicioEnvio = data.dataInicioEnvioAgendamento ? moment(data.dataInicioEnvioAgendamento).format('YYYY-MM-DD') : '';
        this.form.unidades = data.configuracaoDepRndsUnidades;
        this.form.nomeCertificado = data.nomeArquivoCertificado;
        this.form.idSolicitante = data.idSolicitante;
        this.form.numeroDiaSemana = data.numeroDiaSemana;
        this.adicionarCertificado = !data.nomeArquivoCertificado;
        this.form.certificado = null;
        this.form.chaveAcesso = null;
        this.integracaoAtiva = !!data.idConfiguracaoDepartamentoRnds;
        this.responsavelAtivacao = data.nomeAlterador ?? data.nomeCriador;
        this.dataAtivacao = data.alteracao ?? data.criacao;
        this.modalCancel.show = false;
      });
    },

    submitForm() {
      this.$refs.integracaoRules.validate().then((success) => {
        if (!success) {
          this.showErrorModal('Preencha todos os campos obrigatórios corretamente');
          this.modalSubmit.show = false;
          return;
        }
        const isUpdate = !!this.form.idConfiguracaoDepartamentoRnds;
        if (!isUpdate && !this.validarUnidades()) {
          this.showErrorModal('Selecione ao menos uma unidade para integrar');
          this.modalSubmit.show = false;
          return;
        }
        this.saving = true;
        const formData = this.montarFormData();
        const url = isUpdate ? this.$api.editIntegracaoRnds(this.form.idConfiguracaoDepartamentoRnds) : this.$api.saveIntegracaoRnds();
        const config = { headers: { 'Content-Type': 'multipart/form-data', ...(isUpdate && { 'X-HTTP-Method-Override': 'PUT' }) } };
        this.enviarRequest(url, formData, config);
      });
    },

    validarUnidades() {
      return this.form.unidades.some(u => u.permite_integracao_rnds === true);
    },

    montarFormData() {
      const formData = new FormData();
      if (this.form.certificado) formData.append('certificado', this.form.certificado);
      const params = {
        idDepartamento: this.form.departamento.id_departamento,
        chaveAcesso: this.form.chaveAcesso,
        idSolicitante: this.form.idSolicitante,
        dataRegistroEnvio: this.form.dataFiltro,
        periodicidadeAgendamento: this.form.periodicidade,
        dataInicioEnvioAgendamento: this.form.dataInicioEnvio,
        numeroDiaSemana: this.form.numeroDiaSemana,
        configuracaoDepRndsUnidades: this.form.unidades,
        tipoData: this.form.tipoDataFiltro
      };
      Object.entries(params).forEach(([key, value]) => {
        if (key === 'configuracaoDepRndsUnidades') formData.append(key, JSON.stringify(value));
        else if (value != null && value !== '') formData.append(key, value);
      });
      return formData;
    },

    enviarRequest(url, formData, config) {
      this.$http.post(url, formData, config)
        .then(() => { this.modalSucesso.showModal = true; })
        .catch(({ response: { data } }) => {
          handleErrorsService.handleErrosIntegracaoRnds(data, this.form.errors);
          this.showErrorModal(this.form.errors.error);
        })
        .finally(() => { this.saving = false; this.modalSubmit.show = false; });
    },

    showErrorModal(text) {
      this.modalError.showModal = true;
      this.modalError.infoText = text;
    },

    saveAction() {
      this.modalSubmit.show = true;
      this.modalSubmit.infoText = 'Esta ação irá ativar a integração para o Departamento ' + this.form.departamento.descricao;
    },

    cancelAction() { this.modalCancel.show = true; },

    clearForm() {
      this.integracaoAtiva = false;
      this.responsavelAtivacao = null;
      this.dataAtivacao = null;
      Object.assign(this.form, {
        idConfiguracaoDepartamentoRnds: null, certificado: null, nomeCertificado: null,
        dataFiltro: null, periodicidade: null, dataInicioEnvio: null, numeroDiaSemana: null,
        unidades: [], chaveAcesso: null, idSolicitante: null, tipoDataFiltro: 'data_atendimento_vacinacao'
      });
      Object.keys(this.form.errors).forEach(k => { this.form.errors[k] = null; });
    }
  }
};
</script>

<style>
.border-start-blue {
  border-left: 4px solid #2772C0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
</style>
